import type { StatusGroupRes } from 'api/swagger';
import { CargoItemStatus } from './cargo-item-status.tsx';

interface ICargoItemStatusesProps {
  statuses: StatusGroupRes[];
  assetIsReturned?: boolean;
}

export const CargoItemStatuses: React.FC<ICargoItemStatusesProps> = (props) => {
  const { statuses, assetIsReturned } = props;

  return statuses.map((status) => (
    <CargoItemStatus
      key={`${status.type}${status.fromWarehouseId}${status.toWarehouseId}`}
      type={status.type}
      from={status.fromWarehouseId}
      to={status.toWarehouseId}
      count={status.count}
      oneStatus={statuses.length <= 1}
      assetIsReturned={assetIsReturned}
    />
  ));
};
